import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: 0;
  height: 100%;
`;

export const Title = styled.h1`
  color: #181818;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Download = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const DownloadOptions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3px;

  & a {
    cursor: pointer;
    text-decoration: none;
    display: flex;
  }
`;

export const ContentScroller = styled.div.attrs({
  "data-testid": "content-scroll",
} as Record<string, string>)`
  min-height: 0;
  flex: 1 1 auto;
  overflow: auto;
  padding-right: 16px;
`;
